import { render, staticRenderFns } from "./Dvizhenie_magazin.vue?vue&type=template&id=3e333c1e&scoped=true&"
import script from "./Dvizhenie_magazin.vue?vue&type=script&lang=js&"
export * from "./Dvizhenie_magazin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e333c1e",
  null
  
)

export default component.exports